var _path, _g, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_fin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 65,
    viewBox: "0 0 49 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4080",
    "data-name": "\\uD328\\uC2A4 4080",
    d: "M256.483,74.26H232.727V46.545h23.755L252.523,60.4Z",
    transform: "translate(-211.587 -40.606)",
    fill: "#ff9811"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2382",
    "data-name": "\\uADF8\\uB8F9 2382",
    transform: "translate(20.941 5.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4081",
    "data-name": "\\uD328\\uC2A4 4081",
    d: "M231.175,201.7v7.919h23.954l-2.262-7.919Z",
    transform: "translate(-231.175 -181.901)",
    fill: "#bf3c1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4082",
    "data-name": "\\uD328\\uC2A4 4082",
    d: "M255.129,46.545H231.175v7.919h21.691Z",
    transform: "translate(-231.175 -46.545)",
    fill: "#bf3c1a"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4083",
    "data-name": "\\uD328\\uC2A4 4083",
    d: "M231.175,217.212h5.939l-5.939,5.939Z",
    transform: "translate(-209.839 -189.65)",
    fill: "#802812"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1201",
    "data-name": "\\uC0AC\\uAC01\\uD615 1201",
    width: 23.756,
    height: 27.715,
    transform: "translate(4.105)",
    fill: "#ff9811"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1202",
    "data-name": "\\uC0AC\\uAC01\\uD615 1202",
    width: 23.756,
    height: 27.715,
    transform: "translate(4.105)",
    fill: "#ff5023"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1203",
    "data-name": "\\uC0AC\\uAC01\\uD615 1203",
    width: 23.756,
    height: 11.878,
    transform: "translate(4.105 7.918)",
    fill: "#ffda44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1204",
    "data-name": "\\uC0AC\\uAC01\\uD615 1204",
    width: 5.939,
    height: 57.081,
    transform: "translate(4.105)",
    fill: "#3c5d76"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1205",
    "data-name": "\\uC0AC\\uAC01\\uD615 1205",
    width: 5.939,
    height: 27.715,
    transform: "translate(4.105)",
    fill: "#1e2e3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4084",
    "data-name": "\\uD328\\uC2A4 4084",
    d: "M95.3,395.636a14.435,14.435,0,0,0-9.886,3.915,14.436,14.436,0,0,0-9.886-3.915,14.732,14.732,0,0,0-14.614,14.847h49A14.732,14.732,0,0,0,95.3,395.636Z",
    transform: "translate(-60.919 -345.483)",
    fill: "#50412e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4085",
    "data-name": "\\uD328\\uC2A4 4085",
    d: "M266.043,395.636A14.792,14.792,0,0,0,256,399.551v10.932H280.89A14.847,14.847,0,0,0,266.043,395.636Z",
    transform: "translate(-231.89 -345.483)",
    fill: "#2a2718"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFin);
export default __webpack_public_path__ + "static/media/ic_fin.0c1c9d19c3d2eb7c6274a00020053e20.svg";
export { ForwardRef as ReactComponent };